import { createAsyncThunk } from "@reduxjs/toolkit";
import fsrHttpInstance, { fsrHttpConfiguration } from "../serviceFsrClients";
import { normalizeEntity } from "../entities/menuEntity";
import { setFlashSuccess, setFlashError } from "../slices/commons/flashSliceCommon";

export const fetchMenus = createAsyncThunk(
	"datasources/menus/fetchMenus",
	async (request, thunkAPI) => {
		try {
			const params = request ? { params: request.query } : {};
			const response = await fsrHttpInstance.then(fsrService => fsrService.get("vendor/menus/index", {...params, ...fsrHttpConfiguration()}));
			const normalized = normalizeEntity(response.data.menus);
			
			return { 
				...normalized, 
				pagination: response.data.pagination || {} 
			};
		} catch (exception) {
			thunkAPI.dispatch(setFlashError("The menu could not be loaded. Please, try again."));
			return thunkAPI.rejectWithValue(exception.response.data);
		}
	}
);

export const fetchMenu = createAsyncThunk(
	"datasources/menus/fetchMenu",
	async (request, thunkAPI) => {
		try {
			const params = request ? { params: request.query } : {};
			const response = await fsrHttpInstance.then(fsrService => fsrService.get("vendor/menus/view", {...params, ...fsrHttpConfiguration()}));
			const normalized = normalizeEntity(response.data.menu);

			return normalized;
		} catch (exception) {
			thunkAPI.dispatch(setFlashError("The menu could not be loaded. Please, try again."));
			return thunkAPI.rejectWithValue(exception.response.data);
		}
	}
);

export const saveMenu = createAsyncThunk(
	"datasources/menus/saveMenu",
	async (request, thunkAPI) => {
		try {
			const formData = { ...request };
			const action = formData.id ? "edit" : "add";
			const response = await fsrHttpInstance.then(fsrService => fsrService.post(`vendor/menus/${action}`, formData, fsrHttpConfiguration()));

			thunkAPI.dispatch(setFlashSuccess("The menu has been saved."));
			return response.data;
		} catch (exception) {
			thunkAPI.dispatch(setFlashError("The menu could not be saved. Please, try again."));
			return thunkAPI.rejectWithValue(exception.response.data);
		}
	}
);

export const deleteMenu = createAsyncThunk(
	"datasources/menus/deleteMenu",
	async (request, thunkAPI) => {
		try {
			const params = request.query ? { params: request.query } : {};
			const response = await fsrHttpInstance.then(fsrService => fsrService.post("vendor/menus/delete", null, {...params, ...fsrHttpConfiguration()}));

			thunkAPI.dispatch(setFlashSuccess("The menu has been deleted."));
			return response.data;
		} catch (exception) {
			thunkAPI.dispatch(setFlashError("The menu could not be deleted. Please, try again."));
			return thunkAPI.rejectWithValue(exception.response.data);
		}
	}
);